import { GuestModel } from 'api-hooks/guest';
import { useFormState } from 'components/elements/form';
import Popover, { PopoverMenuType } from 'components/popover';
import useDestroyAction from 'hooks/use-destroy-action';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import useGuestCustomerListAction from '../hooks/use-guest-customer-list-action';

interface Props {
  guest: GuestModel;
}

export default function ActionComponent(props: Props) {
  const { t } = useTranslation();

  const { guestCustomerListAction } = useGuestCustomerListAction(props.guest);
  const { deleteAction } = useDestroyAction('guests', props.guest.id);
  const { setIsEditable } = useFormState();
  const permission = useGetCrudPermission('guests');
  const editPermission = permission.update;
  const editAction: PopoverMenuType = {
    key: `editable-${props.guest.id}`,
    label: t('common:edit'),
    onClick: () => {
      setIsEditable(true);
    },
    isAllowed: editPermission,
  };

  const actions = [editAction, guestCustomerListAction, deleteAction].filter(
    (action) => action.isAllowed,
  );

  if (actions.length === 0) return null;

  return (
    <>
      <Popover actions={actions} />
    </>
  );
}
